import { createApp } from 'vue'
import App from './App.vue'
import { setUnauthorizedHandler } from './api'
import { router } from './router'
import './styles.css'

setUnauthorizedHandler(() => {
  if (router.currentRoute.value.name !== 'login') {
    void router.push({ name: 'login', query: { next: router.currentRoute.value.fullPath } })
  }
})

createApp(App).use(router).mount('#app')
